import { render, staticRenderFns } from "./ThumbnailSlotSmallVertical.vue?vue&type=template&id=32e55ea2"
import script from "./ThumbnailSlotSmallVertical.vue?vue&type=script&lang=js"
export * from "./ThumbnailSlotSmallVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports